import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ExpandAllBomProps {
  onExpandAll: () => void;
  onCloseAll: () => void;
}

export const ExpandAllBom = (props: ExpandAllBomProps) => {
  const { onExpandAll, onCloseAll } = props;
  const { t } = useTranslation();
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Tooltip title={t('GROUPING_TOOLBAR_ACTIONS.EXPAND_ALL')}>
        <IconButton color="primary" onClick={onExpandAll}>
          <KeyboardArrowDownIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={t('GROUPING_TOOLBAR_ACTIONS.CLOSE_ALL')}>
        <IconButton color="primary" onClick={onCloseAll}>
          <KeyboardArrowRightIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};
